import { stripApplicationBase } from './appUrl';

export type ApplicationRoute =
  | { readonly kind: 'progress' }
  | { readonly kind: 'beginner-tour' }
  | { readonly kind: 'campaign' }
  | { readonly kind: 'event'; readonly eventId: string };

export interface ApplicationLocation {
  readonly pathname: string;
  readonly search: string;
}

const EVENT_ALIASES: Readonly<Record<string, string>> = {
  hurdles: '110m-hurdles',
  polevault: 'pole-vault',
};

/** Pure route selection kept separate from browser bootstrapping for contract tests. */
export const resolveApplicationRoute = ({
  pathname,
  search,
}: ApplicationLocation, baseUrl = import.meta.env.BASE_URL): ApplicationRoute => {
  pathname = stripApplicationBase(pathname, baseUrl);
  if (pathname === '/progress' || pathname === '/progress/') {
    return { kind: 'progress' };
  }

  const parameters = new URLSearchParams(search);
  if (parameters.get('beginner') === 'events') {
    return { kind: 'beginner-tour' };
  }

  const requestedEventId = parameters.get('event');
  if (parameters.get('campaign') === 'decathlon' || requestedEventId === null) {
    return { kind: 'campaign' };
  }

  return {
    kind: 'event',
    eventId: EVENT_ALIASES[requestedEventId] ?? requestedEventId,
  };
};
